import React, { useContext } from 'react';
import Layout from './Layout';
import EventContext from '../contexts/EventContext';
import useFetchPartenaireList from '../customHooks/useFetchPartenaireList';
import PromptAi from './PromptAi';
import RegistrationDashboardLayout from './RegistrationDashboardLayout';



// creer un customhook pour fetchData


const PostGenerator = () => {

    const { currentEvent } = useContext(EventContext);
    const { data: intervenants, loading, error } = useFetchPartenaireList();


    const generatePromptForRow = (intervenant) => {
        if (!intervenant || !currentEvent) return "";

        const { contact: { prenom, nom, societe }, punchline } = intervenant;

        return `À l'occasion de "${currentEvent.nom}", peux-tu me rédiger un post LinkedIn afin de valoriser l'interview de ${prenom} ${nom} de la société ${societe} autour du thème "${punchline}".`;
    };

    return (
        <RegistrationDashboardLayout>
            <div className="p-8">
                <header className="mb-8">
                    <h1 className="text-3xl font-bold">Générateur de Posts IA</h1>
                    <p className="text-gray-400 mt-1">Générez des prompts et des suggestions de posts pour valoriser vos intervenants.</p>
                </header>

                <div className="w-full mx-auto">
                    {loading && <p>Chargement des intervenants...</p>}
                    {error && <p className="text-red-500">Erreur : {error}</p>}
                    {!loading && !error && (
                        <div className="space-y-8">
                            {intervenants && intervenants.map((intervenant) => {
                                const promptText = generatePromptForRow(intervenant);
                                return (
                                    <div key={intervenant.id_conferencier} className="bg-white p-6 rounded-xl shadow-md">
                                        <div className="mb-4">
                                            <h3 className="text-lg font-bold text-gray-900">{intervenant.contact.prenom} {intervenant.contact.nom}</h3>
                                            <p className="text-sm text-gray-500">{intervenant.contact.societe}</p>
                                        </div>
                                        <PromptAi prompt={promptText} />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </RegistrationDashboardLayout>
    );
};

export default PostGenerator;